import React, { FC } from 'react';
import { WelcomeMessageComponent, WelcomeMessageButton } from './WelcomeMessage.styles';
import { WelcomeMessageTypes } from './types';
import { Callout } from 'components/atoms';
import { useMsal } from '@azure/msal-react';
import { useAuth } from 'auth';

const WelcomeMessage: FC<WelcomeMessageTypes> = ({ avatar, dark = false, name }) => {
  const { instance } = useMsal();
  const { setTokenInfo } = useAuth();
  return (
    <WelcomeMessageComponent dark={dark}>
      <Callout
        name="User account menu"
        trigger={() => (
          <>
            {name && (
              <p>
                Welcome Back, <strong>{name}</strong>
              </p>
            )}
            {avatar && <img src={avatar} alt={`${name} user avatar`} width="45" height="45" />}
          </>
        )}
      >
        <WelcomeMessageButton
          onClick={() => {
            setTokenInfo(null);
            instance.logoutRedirect();
          }}
        >
          Logout
        </WelcomeMessageButton>
      </Callout>
    </WelcomeMessageComponent>
  );
};

export default WelcomeMessage;
